import { useSelector } from "react-redux";
import { AppState } from "../store";

export const GetUserToken: any = () =>
  useSelector((state: AppState) => state.user.token);
export const GetUserName: any = () =>
  useSelector((state: AppState) => state.user.username);
export const GetUserEmail: any = () =>
  useSelector((state: AppState) => state.user.email);
